/* Modulo: Category Slant — scroll-snap arrow controller.
   The rail swipes/scrolls natively (works with no JS); this only wires the
   prev/next arrows and their disabled state. Vanilla, reduced-motion aware. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function step(rail, card) {
    if (!card) return rail.clientWidth * 0.8;
    var mr = parseFloat(window.getComputedStyle(card).marginRight) || 0;
    return card.getBoundingClientRect().width + mr; // effective advance per card
  }

  function init(root) {
    if (!root || root.dataset.moduloCslReady === '1') return;
    root.dataset.moduloCslReady = '1';

    var rail = root.querySelector('[data-modulo-csl-rail]');
    if (!rail) return;
    var prev = root.querySelector('[data-modulo-csl-prev]');
    var next = root.querySelector('[data-modulo-csl-next]');
    var rtl = window.getComputedStyle(rail).direction === 'rtl';

    function sync() {
      var max = rail.scrollWidth - rail.clientWidth;
      var pos = Math.abs(rail.scrollLeft);
      if (prev) prev.disabled = pos <= 2;
      if (next) next.disabled = pos >= max - 2;
    }

    function page(dir) {
      var card = rail.querySelector('.modulo-csl__card');
      var s = step(rail, card);
      var perClick = Math.max(1, Math.floor(rail.clientWidth / s));
      var delta = dir * s * perClick * (rtl ? -1 : 1);
      rail.scrollBy({ left: delta, behavior: REDUCE ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });

    var raf = null;
    rail.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    });

    var rt = null;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(sync, 100);
    });

    sync();
  }

  function boot(scope) {
    var els = (scope || document).querySelectorAll('[data-modulo-csl]');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // Shopify theme editor: (re)init when a section is added/redrawn
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
